import { Dispatch, SetStateAction, useMemo } from 'react';

import { IPill } from 'partsOld/types';

import { DragAndDropHeader } from '../dragAndDrop';
import ImportTableModalView from './ImportTableModalView';

interface IProps {
  isUploadSuccessful: boolean;
  initialPills: IPill[];
  pills: IPill[];
  clearHeaders: () => void;
  onCheckboxChange: (isPricing: boolean) => void;
  isLoading: boolean;
  pricingCheckbox: boolean;
  quantityCheckbox: boolean;
  setAddNewHeader: Dispatch<SetStateAction<boolean>>;
  addNewHeader: boolean;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  records: Array<Array<string>>;
  fetchNextPage;
  onConfirmMapping: () => Promise<void>;
}

const ImportTableModal = ({
  isUploadSuccessful,
  initialPills,
  clearHeaders,
  onCheckboxChange,
  records,
  isLoading,
  pills,
  pricingCheckbox,
  quantityCheckbox,
  addNewHeader,
  setAddNewHeader,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
  onConfirmMapping,
}: IProps) => {
  const [firstElement, ...rest] = records;
  const data = addNewHeader ? records : rest;

  const columns = useMemo(() => {
    return firstElement?.map((item, idx) => {
      return {
        Header: (
          <DragAndDropHeader
            item={item}
            index={idx}
            initialPills={pills.flat()}
            addNewHeader={addNewHeader}
          />
        ),
        accessor: idx.toString(),
      };
    });
  }, [records]);

  return (
    <ImportTableModalView
      {...{
        isUploadSuccessful,
        isLoading,
        initialPills,
        columns,
        records: data,
        clearHeaders,
        onCheckboxChange,
        quantityCheckbox,
        pricingCheckbox,
        setAddNewHeader,
        addNewHeader,
        hasNextPage,
        isFetchingNextPage,
        fetchNextPage,
        onConfirmMapping,
      }}
    />
  );
};

export default ImportTableModal;
